import React from 'react';
import { MpTextField } from '../../../../components';
import { useTranslation } from '../../../../hooks';

interface IProps {
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  isDisabled?: boolean;
}

const CurrentExchangeRateTextField = (props: IProps) => {
  const { label, value, onChange, isDisabled } = props;
  const { tc, t } = useTranslation('exchangeRate');

  return (
    <MpTextField
      label={label || tc('phInputField', { fieldName: t('currentExchangeRate') })}
      value={value}
      onChange={onChange}
      disabled={isDisabled}
      fullWidth
      showDecimalKeyboard
    />
  );
};

export default CurrentExchangeRateTextField;
